import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Alert, Box, CircularProgress, Container } from '@mui/material';
import { apiClient } from '../services/api';
import MissingAgentsShareContent from '../components/dashboard/MissingAgentsShareContent';
import { MissingAgentRow } from '../utils/attendanceLabels';

const MissingAgentsSharePage: React.FC = () => {
  const { token } = useParams<{ token: string }>();

  const { data, isLoading, error } = useQuery({
    queryKey: ['missingAgentsShare', token],
    queryFn: async () => {
      const response = await apiClient.dashboard.getMissingAgentsShare(token!);
      return response.data.data;
    },
    enabled: Boolean(token),
  });

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !data?.payload) {
    return (
      <Container maxWidth="sm" sx={{ py: 4 }}>
        <Alert severity="error">This missing agents share link was not found or has expired.</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <MissingAgentsShareContent
        agents={data.payload.agents as MissingAgentRow[]}
        workDate={data.payload.workDateLabel || data.workDate}
        generatedAt={data.payload.generatedAt}
      />
    </Container>
  );
};

export default MissingAgentsSharePage;
